import * as Dialog from "@radix-ui/react-dialog";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconCaretDownAccount from "../../../../img/icons/caret-down-account.svg";
import iconCircleClose from "../../../../img/icons/circle-close.svg";
import { SVGIcon } from "../../../components/SVGIcon";
import { useAppSelector } from "../../../store/reducers";
import { useIsSSR } from "../../../utils/ssr";
import { AccountMenuContent } from "../AccountMenuContent/index";

import styles from "./index.module.scss";

type IProps = Immutable<{
    // Radix's Dialog.Trigger auto-emits the dialog-disclosure ARIA
    // (aria-haspopup="dialog", aria-expanded, and aria-controls while open). When
    // set, this drops all three so the account trigger is announced as a plain
    // control rather than a dialog disclosure -- the sealy design's intent for
    // this "Support" / "Hi, {name}" trigger. Left off (default) elsewhere, so
    // other sites keep Radix's disclosure semantics unchanged.
    suppressTriggerDisclosureAria?: boolean;
}>;

export const AccountMenu = (props: IProps): React.JSX.Element => {
    const isSSR = useIsSSR();
    const user = useAppSelector((state) => state.common.user);
    let accountText: string = t`Support`;
    if (user && user.first_name && user.has_password) {
        accountText = t`Hi, ${user.first_name}`;
    }
    return (
        <div>
            <Dialog.Root>
                <Dialog.Trigger
                    className={styles.accountMenuLink}
                    {...(props.suppressTriggerDisclosureAria
                        ? {
                              "aria-haspopup": undefined,
                              "aria-expanded": undefined,
                              "aria-controls": undefined,
                          }
                        : {})}
                >
                    <span className={styles.accountMenuLinkText}>
                        {accountText}
                        &nbsp;
                        <SVG
                            src={iconCaretDownAccount}
                            title={t`View Account Icon`}
                            aria-hidden="true"
                        />
                    </span>
                    <span className={styles.accountMenuLinkIcon}>
                        <SVGIcon
                            name="mobileAccount"
                            alt={t`View Account Icon`}
                            aria-hidden="true"
                        />
                    </span>
                </Dialog.Trigger>
                <div className={styles.wrapper}>
                    <Dialog.Content
                        className={styles.container}
                        aria-describedby={undefined}
                        aria-label={t`Support`}
                        aria-modal={true}
                    >
                        <Dialog.Close
                            className={styles.closeButton}
                            aria-label={t`Close`}
                        >
                            <SVG src={iconCircleClose} aria-hidden="true" />
                        </Dialog.Close>
                        {!isSSR && <AccountMenuContent user={user} />}
                    </Dialog.Content>
                </div>
            </Dialog.Root>
        </div>
    );
};
